<template>
  <div class="course_pack pa-3 pa-sm-6 ma-n3 ma-sm-n6">
    <div class="custom-contents--hero pb-10">
      <p class="text-h6 mb-3">おすすめコースをパックにしました!</p>
      <p
        class="mb-5"
        style="font-size: 90%"
      >
        何を選んだらよいか分からない、自分にあったコースは何？そんな方のためにおすすめコースをパックにしました。<br>これを選んで達成すれば、気になる不調も軽減されるはずです。
      </p>
      <v-alert
        border="left"
        colored-border
        type="warning"
        elevation="2"
        style="font-size: 90%"
        class="my-4"
      >
        <ul>
          <li>パックは1つのみ選択できます。（パックは2つ以上選択できません）</li>
          <li>パックは達成条件を満たしたコース数で1パックになっています。パック内のコースを変更することはできません。</li>
        </ul>
      </v-alert>
    </div>
    <div class="custom-contents--chooses mb-13 pb-13">
      <div v-for="(category, i) in categoryList" :key="i" class="mt-10">
        <header class="mb-4">
          <h2
            class="text-h6 font-weight-bold text-left"
          >
            ■{{ category.title }}
          </h2>
        </header>
        <v-row>
          <v-col
            v-for="(pack, i) in category.packList"
            :key="i"
            cols="12"
            md="4"
          >
            <v-card
              class="fill-height rounded-sm d-flex align-start flex-column"
              :elevation="3"
              tile
            >
              <h3
                class="d-block custom-w--100 text-center font-weight-bold pa-3 custom-bg--maingreen white--text"
              >
                {{ pack.pack_name }}
              </h3>
              <div
                class="mb-auto pt-5 pb-3 px-5 text-body-2"
              >
                {{ pack.pack_target }}
              </div>
              <div class="pr-5 pb-5 text-right custom-w--100">
                  <v-btn
                    @click="scrollToAnchorPoint(pack.id)"
                    class="custom-btn--choose rounded-xl font-weight-bold"
                    :elevation="0"
                    outlined
                  >パック詳細を見る
                    <v-icon
                      class="pl-4"
                      dark
                      left
                    >
                      mdi-arrow-down
                    </v-icon>
                  </v-btn>
                </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <div class="custom-contents--packs">
      <div v-for="(category, i) in categoryList" :key="i"
        class="custom-contents-in--packs"
      >
        <div
        v-for="(pack, i) in category.packList"
          :key="i"
          :ref="pack.id"
          class="custom-contents--course custom-scrollpoint"
        >
          <v-card
            :elevation="0"
          >
            <header
              class="d-flex flex-wrap align-center px-md-10 px-5 py-5 white--text font-weight-bold custom-title--pack custom-w--100 custom-bg--maingreen"
            >
              <div
                class="d-flex align-center"
              >
                <div class="custom-icon--pack d-flex mr-4">
                  <svg width="35" height="26" viewBox="0 0 35 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.49001 26C1.85367 26 1.27959 25.7495 0.767753 25.2484C0.255918 24.7474 0 24.1854 0 23.5625V2.4375C0 1.81458 0.255918 1.2526 0.767753 0.751562C1.27959 0.250521 1.85367 0 2.49001 0H13.114C13.4461 0 13.7711 0.0677083 14.0893 0.203125C14.4075 0.338542 14.6772 0.514583 14.8986 0.73125L16.6416 2.4375H30.7101C31.3465 2.4375 31.9205 2.68802 32.4324 3.18906C32.9442 3.6901 33.2001 4.25208 33.2001 4.875H4.98002C4.28835 4.875 3.70043 5.11198 3.21626 5.58594C2.73209 6.0599 2.49001 6.63542 2.49001 7.3125V23.5625L6.22502 9.14062C6.36336 8.59896 6.66769 8.15885 7.13803 7.82031C7.60836 7.48177 8.1202 7.3125 8.67353 7.3125H32.4531C33.2555 7.3125 33.9195 7.62396 34.4451 8.24687C34.9708 8.86979 35.123 9.57396 34.9016 10.3594L31.2496 24.1312C31.0836 24.7812 30.7793 25.2552 30.3366 25.5531C29.8939 25.851 29.3268 26 28.6351 26H2.49001Z" fill="white"/>
                  </svg>
                </div>
                <h2>
                  {{ pack.pack_name }}
                </h2>
                </div>
                <div class="d-flex pl-md-0 pl-9 mt-md-0 mt-3 custom-header-btn--pack">
                  <v-btn
                    @click="setCoursePack(pack.id)"
                    class="ml-md-6 ml-3 pl-md-6 pl-4 pr-md-3 pr-1 rounded-xl font-weight-bold custom-btn--pack"
                    text
                    :elevation="0"
                  >
                  このパックを選ぶ
                  <v-icon>mdi-menu-right</v-icon>
                  </v-btn>
                </div>
              </header>
            <div
              class="py-md-8 py-6 px-md-10 px-6"
            >
              <div class="text-body-2 pb-8">
                {{ pack.pack_detail }}
              </div>
              <template>
                <div>
                  <v-expansion-panels class="custom-panels--pack">
                    <v-expansion-panel
                      v-for="(course, i) in pack.pack_course_list"
                      :key="i"
                      class="custom-panels-panel--pack"
                    >
                      <v-expansion-panel-header
                        class="custom-panel-header--pack pt-6 pb-md-6 pb-5"
                      >
                        <template v-slot:actions>
                          <p
                            class="custom-panel-header-icon--pack rounded-circle"
                          >
                            <v-icon>
                              mdi-minus
                            </v-icon>
                          </p>
                        </template>
                        <div
                          class="pl-9 custom-panel-header-text--pack"
                        >
                          <span
                            class="d-block custom-panel-header-subtitle--pack"
                          >
                            {{ findCourse(course.course_id).sub_title }}
                          </span>
                          <span
                            class="d-block pt-1 font-weight-bold custom-panel-header-title--pack"
                          >
                          {{ findCourse(course.course_id).name }}
                          </span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row
                          class="pl-9 pr-md-9 pr-0 pb-md-5 pb-2"
                          no-gutters
                        >
                          <v-col
                            cols="12"
                            md="4"
                            class="pr-7 pb-md-0 pb-5 pt-md-0 pt-2 custom-panel--achievement"
                          >
                            <dl
                              class="fill-height"
                            >
                              <dt class="pb-1 font-weight-bold custom-color--maingreen">達成基準</dt>
                              <dd class="text-body-2">{{ findCourse(course.course_id).objective }}</dd>
                            </dl>
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                            class="pl-md-7 py-md-0 py-5 custom-panel--basicitem"
                          >
                            <dl
                              class="fill-height"
                            >
                              <dt class="pb-1 font-weight-bold custom-color--maingreen">基本項目</dt>
                              <dd class="text-body-2" v-html="findCourse(course.course_id).basic_item"></dd>
                            </dl>
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                            class="text-right pl-md-7"
                          >
                            <v-btn
                            @click="openDetailPDF(findCourse(course.course_id).detailed_document_file_name)"
                              target="_blank"
                              class="d-inline-block px-14 py-3 font-weight-bold rounded-xl custom-bg--maingreen custom-btn--pdf"
                              height="auto"
                              text
                              dark
                            >
                              <span>詳しくはこちら</span>
                              <span class="d-inline-flex ml-4 custom-icon--pdf">
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M7.92 10.065H9.24C9.52829 10.065 9.76994 9.96748 9.96496 9.77246C10.16 9.57744 10.2575 9.33579 10.2575 9.0475V7.7275C10.2575 7.43921 10.16 7.19756 9.96496 7.00254C9.76994 6.80752 9.52829 6.71 9.24 6.71H7.425C7.28567 6.71 7.16375 6.75583 7.05925 6.8475C6.95475 6.93917 6.9025 7.06208 6.9025 7.21625V11.8413C6.9025 11.9954 6.95475 12.1183 7.05925 12.21C7.16375 12.3017 7.28567 12.3475 7.425 12.3475C7.57167 12.3475 7.69083 12.2952 7.7825 12.1907C7.87417 12.0862 7.92 11.9643 7.92 11.825V10.065ZM7.92 9.0475V7.7275H9.24V9.0475H7.92ZM13.7775 12.3475C14.0525 12.3475 14.2908 12.25 14.4925 12.055C14.6942 11.8599 14.795 11.6183 14.795 11.33V7.7275C14.795 7.43921 14.6942 7.19756 14.4925 7.00254C14.2908 6.80752 14.0525 6.71 13.7775 6.71H11.99C11.8507 6.71 11.7288 6.75583 11.6243 6.8475C11.5198 6.93917 11.4675 7.06167 11.4675 7.21501V11.815C11.4675 11.9683 11.5198 12.0954 11.6243 12.1962C11.7288 12.2971 11.8507 12.3475 11.99 12.3475H13.7775ZM12.485 11.33V7.7275H13.7775V11.33H12.485ZM17.16 10.065H18.04C18.1867 10.065 18.3058 10.0127 18.3975 9.90825C18.4892 9.80375 18.535 9.68183 18.535 9.5425C18.535 9.39583 18.4892 9.27667 18.3975 9.185C18.3058 9.09333 18.1867 9.0475 18.04 9.0475H17.16V7.7275H18.04C18.1867 7.7275 18.3058 7.67525 18.3975 7.57075C18.4892 7.46625 18.535 7.34433 18.535 7.205C18.535 7.05833 18.4892 6.93917 18.3975 6.8475C18.3058 6.75583 18.1867 6.71 18.04 6.71H16.665C16.5257 6.71 16.4037 6.75583 16.2992 6.8475C16.1947 6.93917 16.1425 7.06208 16.1425 7.21625V11.8413C16.1425 11.9954 16.1947 12.1183 16.2992 12.21C16.4037 12.3017 16.5257 12.3475 16.665 12.3475C16.8117 12.3475 16.9308 12.2952 17.0225 12.1907C17.1142 12.0862 17.16 11.9643 17.16 11.825V10.065ZM4.95 18.7C4.51 18.7 4.125 18.535 3.795 18.205C3.465 17.875 3.3 17.49 3.3 17.05V1.65C3.3 1.21 3.465 0.825 3.795 0.495C4.125 0.165 4.51 0 4.95 0H20.35C20.79 0 21.175 0.165 21.505 0.495C21.835 0.825 22 1.21 22 1.65V17.05C22 17.49 21.835 17.875 21.505 18.205C21.175 18.535 20.79 18.7 20.35 18.7H4.95ZM4.95 17.05H20.35V1.65H4.95V17.05ZM1.65 22C1.21 22 0.825 21.835 0.495 21.505C0.165 21.175 0 20.79 0 20.35V4.125C0 3.89125 0.0795209 3.69531 0.238563 3.53719C0.397623 3.37906 0.594706 3.3 0.829813 3.3C1.06494 3.3 1.26042 3.37906 1.41625 3.53719C1.57208 3.69531 1.65 3.89125 1.65 4.125V20.35H17.875C18.1087 20.35 18.3047 20.4295 18.4628 20.5886C18.6209 20.7476 18.7 20.9447 18.7 21.1798C18.7 21.4149 18.6209 21.6104 18.4628 21.7663C18.3047 21.9221 18.1087 22 17.875 22H1.65Z" fill="white"/>
                                </svg>
                              </span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </template>
            </div>
          </v-card>
          <div
            class="pt-3 text-right"
          >
            <v-btn
              @click="toTop"
              text
              :elevation="0"
            >
              <v-icon
                class="pl-4"
                dark
                left
              >
                mdi-arrow-up
              </v-icon>
              <span class="text-decoration-underline">TOPへ戻る</span>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
const listCoursePackQuery = (campaignId) => `
query listCoursePack {
  listCoursePack(
    campaign_id: "${campaignId}"
    ) {
      course_packs {
        id
        pack_name
        pack_target
        pack_detail
        pack_category
        pack_course_list {
          course_id
          course_detail
        }
      }
    }
  }
  `
const getListCoursePackQuery = async (campaignId) => {
  const { data: { listCoursePack: data } } = await GraphqlAPI(listCoursePackQuery(campaignId))
  return data
}
const listCourseQuery = (campaignId) => `
  query getListCourse {
    listCourse(campaign_id: "${campaignId}") {
      courses {
        id
        name
        objective
        basic_item
        detailed_document_file_name
        sub_title
      }
    }
  }
`
const getListCourse = async (campaignId) => {
  const { data: { listCourse: data } } = await GraphqlAPI(listCourseQuery(campaignId))
  return {
    courses: data.courses.map((item) => {
      return {
        id: item.id,
        name: item.name,
        objective: item.objective,
        basic_item: item.basic_item,
        detailed_document_file_name: item.detailed_document_file_name,
        sub_title: item.sub_title
      }
    })
  }
}
export default {
  name: 'coursePack',
  components: {
  },
  data () {
    return {
      courseList: [],
      categoryList: []
    }
  },
  computed: {
    getCampaign () {
      return this.$store.getters.getCampaign
    }
  },
  async created () {
    if (!this.getCampaign.id) {
      await this.$store.dispatch('initCampaign', false)
    }
  },
  async mounted () {
    const courseList = await getListCourse(this.getCampaign.id)
    this.courseList = courseList.courses
    const coursePackList = await getListCoursePackQuery(this.getCampaign.id)
    const categoryNameList = []
    coursePackList.course_packs.forEach(coursePack => {
      if (coursePack.pack_category && !categoryNameList.includes(coursePack.pack_category)) {
        categoryNameList.push(coursePack.pack_category)
        const packs = coursePackList.course_packs.filter((pack) => {
          return pack.pack_category === coursePack.pack_category
        })
        this.categoryList.push({ title: coursePack.pack_category, packList: packs })
      }
    })
  },
  methods: {
    toTop () {
      this.$vuetify.goTo(0)
    },
    scrollToAnchorPoint (refName) {
      const el = this.$refs[refName][0]
      el.scrollIntoView({ behavior: 'smooth' })
    },
    // コース選択画面に遷移し、選択したコースパックを選択している状態にする。
    setCoursePack (id) {
      this.$router.push({ name: 'course', params: { routedCoursePackId: id } }, () => {})
    },
    findCourse (courseId) {
      const course = this.courseList.find(course => course.id === courseId)
      return course
    },
    openDetailPDF (target) {
      window.open('/course/detail/' + target + '.pdf', '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
  /* mixin */
  // break point
  $breakpoints: (
    'sm': (max-width: 599px),
    'md': (max-width: 959px),
  ) !default;

  @mixin mq($breakpoint) {
    @if map-has-key($breakpoints, $breakpoint) {
      @media screen and #{inspect(map-get($breakpoints, $breakpoint))} {
        @content;
      }
    }
    @else {
      @error "指定されたブレークポイントは定義されていません。" + "指定できるブレークポイントは次のとおりです。 -> #{map-keys($breakpoints)}";
    }
  }

  /* color */
  $color-main-green: #02AB98;
  $color-main-beige: #FFFBF1;

  /* 上書き */
  .v-btn { letter-spacing: 0;}
  .theme--light.v-expansion-panels .v-expansion-panel:not(:first-child)::after { border-color: rgba(0, 0, 0, 0);}

  /* common */
  .custom-bg--maingreen { background-color: $color-main-green;}
  .custom-color--maingreen { color: $color-main-green;}
  .custom-w--100 { width: 100%;}

  /* スクロールポイント */
    .custom-scrollpoint {
    margin-top: -48px;
    padding-top: 48px;
  }

  /* ページ親 */
  .course_pack {
    background-color: #F6F6F6;//page => bg
  }

  /* choose */
  .custom-btn--choose {
    &.v-btn {
      color: $color-main-green;

      &.v-btn--has-bg {
          background-color: #fff;
      }
      &.v-btn--outlined {
          border-color: $color-main-green;
      }
    }
  }

  /* pack */
  .custom-contents--packs {
    .custom-contents-in--packs {
    }
    .custom-contents--course {
      padding-bottom: 50px;
    }
  }
  .custom-title--pack {
    h2 {
      font-size: 1.78rem;
      @include mq(md) {
        font-size: 1.294rem;
        }
      }
    .custom-icon--pack {
      @include mq(md) {
        width: 32px;
      }
      svg {
        @include mq(md) {
          width: 32px;
          height: 24px;
        }
      }
    }
    .custom-header-btn--pack {
      @include mq(md) {
        width: 100%;
      }
    }
    .custom-btn--pack {
      font-size: 1.1rem;
      @include mq(md) {
        font-size: 0.875rem;
      }
      &.v-btn {
        height: 40px;
        color: $color-main-green;
        background-color: #fff;

        @include mq(md) {
          height: 36px;
        }
      }
      .v-icon {
        font-size: 32px;
      }
    }
  }
  .custom-panel-header--pack {
    .custom-panel-header-title--pack {
      font-size: 1.5rem;
      line-height: 2rem;
      @include mq(md) {
        font-size: 1.058rem;
        line-height: 1.5rem;
      }
    }
    .custom-panel-header-subtitle--pack {
      font-size: 1.1rem;
      line-height: 1.25rem;
      @include mq(md) {
        font-size: 0.825rem;
        line-height: 1rem;
      }
    }
    .custom-panel-header-icon--pack {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      border: 2px $color-main-green solid;
      &::after {
        content: '';
        display: block;
        opacity: 1;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 2px;
        height: 14px;
        background-color: $color-main-green;
        transition: opacity 0.2s;
      }
      .v-icon {
          color: $color-main-green !important;
      }
    }
    &.v-expansion-panel-header--active {
      .custom-panel-header-icon--pack {
        &::after {
          content: '';
          opacity: 0;
        }
      }
    }
  }
  .custom-panels--pack {
    .custom-panels-panel--pack {
      margin-bottom: 10px;
      background-color: $color-main-beige;
      &:nth-last-of-type(1) {
        margin-bottom: 0;
      }
      .custom-panel--achievement {
        border-right: 1px #A0A0A0 solid;
        @include mq(md) {
          border-right: none;
          border-bottom: 1px #A0A0A0 solid;
        }
      }
      &.v-expansion-panel::before {
        display: none;
      }
    }
    .custom-btn--pdf {
      @include mq(md) {
        width: 100%;
      }
    }
  }
</style>
